import { Fulltime } from './fulltime.interface';

export interface EligibleFulltimeCriteria {
   companyJointCommitteeId?: number | string | null;
   workerStatuteId?: number | string | null;
   workerTypeId?: number | string | null;
}

function hasId(value: unknown): boolean {
   return value !== null && value !== undefined && value !== '';
}

function sameId(left: unknown, right: unknown): boolean {
   return left == right;
}

/**
 * Maatmannen offered when creating a contract or contract template.
 * Joint committee always has to match.
 * Statute and worker type only exclude a maatman when that maatman itself has the field set.
 * Most maatmannen leave both empty, and those stay available for every statute and worker type.
 */
export function filterEligibleFulltimes(fulltimes: Array<Fulltime>, criteria: EligibleFulltimeCriteria): Array<Fulltime> {
   return fulltimes.filter((fulltime) => {
      if (hasId(criteria.companyJointCommitteeId) && !sameId(fulltime.company_joint_committee_id, criteria.companyJointCommitteeId)) {
         return false;
      }

      if (
         hasId(criteria.workerStatuteId) &&
         hasId(fulltime.worker_statute_id) &&
         !sameId(fulltime.worker_statute_id, criteria.workerStatuteId)
      ) {
         return false;
      }

      if (hasId(criteria.workerTypeId) && hasId(fulltime.worker_type_id) && !sameId(fulltime.worker_type_id, criteria.workerTypeId)) {
         return false;
      }

      return true;
   });
}
